export default  {"src":"/_next/static/image/public/icon_exchange.2dcf2cd2832480fdf445f4c1fb33315f.svg","height":16,"width":16};